import(/* webpackMode: "eager" */ "H:\\WORK\\datapulse\\client\\src\\app\\layout.tsx");
